module.exports = __webpack_public_path__ + "static/media/christie-win.e57759d3.png";